
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IDefinicaoOcorrencia, IDefinicaoOcorrenciaTipo } from '@/models/Entidades/IDefinicaoOcorrencia';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoDefinicaoOcorrencia from '@/servicos/ServicoDefinicaoOcorrencia';
import { IResposta } from '@/core/models/IResposta';
import ComboTipo from '@/components/ComboTipo.vue';
import ComboLeiConsideracao from '@/components/ComboLeiConsideracao.vue';
import EditorHtml from '@/core/components/UI/EditorHtml.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';

export default defineComponent({
  name: 'DefinicaoOcorrenciaCadastro',
  components: {
    ComunicacaoApi,
    ComboTipo,
    ComboLeiConsideracao,
    EditorHtml,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicoDefinicaoOcorrencia = new ServicoDefinicaoOcorrencia();

    const state = reactive({
      definicaoOcorrencia: {} as IDefinicaoOcorrencia,
      codigosTipos: [] as number[],
    });

    async function obterdefinicaoOcorrencia(codigo:number) {
      appBase.carregando = true;
      state.definicaoOcorrencia = await servicoDefinicaoOcorrencia.obter(codigo);

      state.codigosTipos = [];

      if (UtilitarioGeral.validaLista(state.definicaoOcorrencia.tipos)) {
        state.definicaoOcorrencia.tipos.forEach((tipo:IDefinicaoOcorrenciaTipo) => {
          state.codigosTipos.push(tipo.codigoTipo);
        });
      }

      appBase.carregando = false;
    }

    function limparDados() {
      state.codigosTipos = [];
      state.definicaoOcorrencia = {} as IDefinicaoOcorrencia;
      state.definicaoOcorrencia.codigo = 0;
      state.definicaoOcorrencia.status = true;
      state.definicaoOcorrencia.tipos = [];
    }

    onBeforeMount(async () => {
      limparDados();
      const codigodefinicaoOcorrencia = obterCodigoRota();
      if (codigodefinicaoOcorrencia > 0) {
        await obterdefinicaoOcorrencia(codigodefinicaoOcorrencia);
      }
    });

    function preparaPersistenciaTipos() {
      const definicoesOcorrenciasTipo: IDefinicaoOcorrenciaTipo[] = [];
      if (state.codigosTipos.length > 0) {
        state.codigosTipos.forEach((tipo) => {
          const tipoDefinicaoOcorrenciaExistente = state.definicaoOcorrencia.tipos.find((c) => c.codigoTipo === tipo);
          if (tipoDefinicaoOcorrenciaExistente !== undefined) {
            definicoesOcorrenciasTipo.push(tipoDefinicaoOcorrenciaExistente);
          } else {
            const tipoDefinicaoOcorrencia: IDefinicaoOcorrenciaTipo = { codigo: 0, codigoDefinicaoOcorrencia: state.definicaoOcorrencia.codigo, codigoTipo: tipo };
            definicoesOcorrenciasTipo.push(tipoDefinicaoOcorrencia);
          }
        });
      }
      state.definicaoOcorrencia.tipos = definicoesOcorrenciasTipo;
    }

    async function salvar() {
      preparaPersistenciaTipos();
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da definição de Ocorrências.');
      if (state.definicaoOcorrencia.codigo === 0) {
        appBase.resposta = await servicoDefinicaoOcorrencia.incluir(state.definicaoOcorrencia);
      } else {
        appBase.resposta = await servicoDefinicaoOcorrencia.atualizar(state.definicaoOcorrencia);
      }

      apresentarRespostaRedirecionamento('DefinicaoOcorrencias');
    }
    return {
      appBase,
      state,
      salvar,
    };
  },
});
